import level3TestataDellaBollettaIntestazione   from './level3-01-testata-01-intestazione.js';
import level3TestataDellaBollettaDatiFornitura  from './level3-01-testata-02-datifornitura.js';
import level3TestataDellaBollettaDatiCliente    from './level3-01-testata-03-daticliente.js';
import level3TestataDellaBollettaDatiBolletta   from './level3-01-testata-04-datibolletta.js';
import level3TestataDellaBollettaTotaleDaPagare from './level3-01-testata-05-totaledapagare.js';

const data = {
    "intestazione": {
      label: "Intestazione",
      img: "./images/01-testata-01-intestazione.jpg",
      imgDescription: "Primo foglio della bolletta di cui viene messo in evidenza il logo di Servizio Elettrico Nazionale, i dati dell'intestatario e l'icona di una lampadina.",
      description: "La parte superiore del primo foglio riporta alcune informazioni di base sulla bolletta e sulla fornitura.",
      labelKeywords: ["intestazione", "intestazioni"],
      contentKeywords: ["intestazione", "intestazioni"],
      level3: level3TestataDellaBollettaIntestazione
    },
    "dati-fornitura": {
      label: "Dati fornitura",
      img: "./images/01-testata-02-datifornitura.jpg",
      imgDescription: "Dettaglio del primo foglio della bolletta che evidenzia tutti i dati della fornitura.",
      description: "In questa sezione troverai raccolti tutti i dati relativi alla tua fornitura, come tariffa, potenza impegnata o tipologia di pagamento della bolletta.",
      labelKeywords: ["dati", "dato", "fornitura"],
      contentKeywords: ["dati", "dato", "fornitura"],
      level3: level3TestataDellaBollettaDatiFornitura
    },
    "dati-cliente": {
      label: "Dati cliente",
      img: "./images/01-testata-03-daticliente.jpg",
      imgDescription: "Immagine che raffigura la prima pagina della bolletta, con evidenziati i campi relativi ai dati del cliente: Numero Cliente, Codice POD e Codice fiscale",
      description: "Sezione della bolletta che riporta i dati di riconoscimento del Cliente, legati alla fornitura.",
      labelKeywords: ["dati", "dato", "cliente"],
      contentKeywords: ["dati", "dato", "cliente"],
      level3: level3TestataDellaBollettaDatiCliente
    },
    "dati-bolletta-sintetica": {
      label: "Dati bolletta sintetica",
      img: "./images/01-testata-04-datibolletta.jpg",
      imgDescription: "Immagine che raffigura la prima pagina della bolletta, con evidenziata l'area relativa ai dati della bolletta (tipo di fornitura, numero fattura, data di emissione, periodo di riferimento)",
      description: "In questa sezione vengono riportate le informazioni che identificano la fattura ricevuta: i dati della fattura e il periodo di riferimento di pagamento.",
      labelKeywords: ["dati", "dato", "bolletta", "sintetica", "sintesi"],
      contentKeywords: ["dati", "dato", "bolletta", "sintetica", "sintesi"],
      level3: level3TestataDellaBollettaDatiBolletta
    },
    "totale-da-pagare": {
      label: "Totale da pagare e scadenza",
      img: "./images/01-testata-05-totaledapagare.jpg",
      imgDescription: "Immagine che raffigura la prima pagina della bolletta, con evidenziato il campo Totale da pagare",
      description: "Queste voci indicano quanto devi pagare, entro quando e il tipo di fattura che hai ricevuto.",
      labelKeywords: ["totale", "pagare", "pagamento", "totale da pagare"],
      contentKeywords: ["totale", "pagare", "pagamento", "totale da pagare"],
      level3: level3TestataDellaBollettaTotaleDaPagare
    }
  }

  export default data;